export const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  subTitle: {
    fontSize: '20px',
    marginBottom: 20,
  },
  footer: {
    padding: '40px',
    display: 'flex',
  },
  downloadLink: {
    marginTop: 20,
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsDeliverability/UploadFile/UploadDeliverabilityReportModalBody/styles.js